import React, {Fragment, useEffect} from 'react';
import BaseGuideModal from './BaseGuideModal';

export default function ChUserCheck ({seen, markAsSeen}) {

  useEffect(() => {
   if (!seen) markAsSeen();
 }, [])
  
  return null;
}